import React from 'react';
import { Box, Typography, TextField } from '@mui/material';

const TextareaQuestion = ({ 
  question, 
  value = '', 
  onChange, 
  interpolateText, 
  answers, 
  error 
}) => {
  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom sx={{ mb: 3, fontWeight: 600, whiteSpace: 'pre-line' }}>
        {interpolateText(question.text, answers)}
      </Typography>
      
      <TextField
        fullWidth
        multiline
        rows={4}
        value={value}
        onChange={handleChange}
        placeholder={question.placeholder || 'Enter your response...'}
        variant="outlined"
        error={!!error}
        helperText={error}
        autoFocus
        sx={{
          '& .MuiOutlinedInput-root': {
            fontSize: '1rem',
            lineHeight: 1.5
          }
        }}
      />
      
      {!question.optional && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Please provide as much detail as you'd like. This helps us serve you better.
        </Typography>
      )}
    </Box>
  );
};

export default TextareaQuestion;